export const languages: Record<string, string> = {
  hy: 'Armenian',
  en: 'English',
  es: 'Spanish',
  pt: 'Portuguese',
  ru: 'Russian',
  uk: 'Ukrainian',
  uz: 'Uzbek',
};
